// extracted by mini-css-extract-plugin
export var hideEditor = "_mo-2";
export var infoIcon = "_mo-3";
export var label = "_mo-1";
export var labelContainer = "_mo-0";
export var readonlyText = "_mo-4";